import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { SalaryIncludes } from './salary-incluce.interface';

export class SalaryIncludeService {
   async getSalaryIncludes(query: any) {
      return http
         .get<PaginatedResponse<SalaryIncludes>>(`/salary-includes`, cacheFirstConfig)
         .then((response) => response.data?.data || []);
   }
}
